// External
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

// Internal

@Injectable({
    providedIn: 'root'
})

export class DropdownService {

    closeAllDropdownEvent: Subject<any> = new Subject();

    constructor() {}

    // send event to close the dropdown
    closeDropdown(event) {
        this.closeAllDropdownEvent.next(event);
    }

}
